import { render } from "./MultiPageComponent.vue?vue&type=template&id=821e1a98"
import script from "./MultiPageComponent.vue?vue&type=script&lang=js"
export * from "./MultiPageComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__